import {Injectable} from '@angular/core';
import {ServerService} from '../services/server.service';
import {Indirizzo} from "./Indirizzo";


export class PuntoVenditaData{
   public id?:number;
   public esercizio?:number;
   public nome?:string;
   public email?:string;
   public telefono?:string;
   public indirizzo?:any;
   public aperto_pubblico?:boolean;
   public index?:number;
   public index_pri?:number;
   public HasTrasfIn?:boolean;

}


@Injectable({
   providedIn: 'root'
})
export class PuntoVenditaFactory {

   constructor(private serverSrv:ServerService) {

   }

   async getPuntiVendita(esercizio_id):Promise<PuntoVendita[]> {
      return new Promise((resolve, reject) => {
         this.serverSrv.getAll(PuntoVendita, `/api/esercizi/${esercizio_id}/puntivendita`).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async getPuntoVendita(esercizio_id_slug, pVenditaId):Promise<PuntoVendita> {
      return new Promise((resolve, reject) => {
         this.serverSrv.get(PuntoVendita, `/api/esercizi/${esercizio_id_slug}/puntivendita/${pVenditaId}`).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   public getPuntiVenditaURL(esercizio_id){
      return `/api/esercizi/${esercizio_id}/puntivendita`
   }

   async putPuntiVendita(esercizio_id, data):Promise<PuntoVendita[]> {
      return new Promise((resolve, reject) => {
         this.serverSrv.putAll(`/api/esercizi/${esercizio_id}/puntivendita`, data, PuntoVendita).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async putPuntoVendita(esercizio_id, pvenditaId, data):Promise<PuntoVendita[]> {
      return new Promise((resolve, reject) => {
         this.serverSrv.putAll(`/api/esercizi/${esercizio_id}/puntivendita/${pvenditaId}`, data, PuntoVendita).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async createPuntoVendita(esercizio_id, data):Promise<PuntoVendita[]> {
      return new Promise((resolve, reject) => {
         this.serverSrv.post(`/api/esercizi/${esercizio_id}/puntivendita`, data, PuntoVendita).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

   async deletePuntoVendita(esercizio_id, p_vendita_id):Promise<PuntoVendita[]> {
      return new Promise((resolve, reject) => {
         this.serverSrv.delete(`/api/esercizi/${esercizio_id}/puntivendita/${p_vendita_id}`).then(res=>{
            resolve(res)
         }).catch(err=>{
            reject(err)
         })
      })
   }

}


export class PuntoVendita {
   public data: PuntoVenditaData = {}
   ID!: number;

   constructor(data:PuntoVenditaData = {}) {
      if(!data) data = {}
      Object.assign(this.data, data);

      if (this.data.id != null) {
         this.ID = this.data.id;
      }

      // if(data.indirizzo){
      //    this.data.indirizzo = new Indirizzo(data.indirizzo);
      //
      // }
      //
      // if(!data.profile)
      //    this.data.profile = new PuntoVenditaProfile();
      // else
      //    this.data.profile = new PuntoVenditaProfile(data.profile);

      // this.IsStaff = this.data.is_staff;
      // this.IsAdmin = this.data.is_superuser || this.data.is_staff;
   }

}
